import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BrightsideUiModule, HeaderLabelCellConfig } from '@brightside/brightside-ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'brightside-web-payroll-pending-card',
    templateUrl: './payroll-pending-card.component.html',
    styleUrl: './payroll-pending-card.component.scss',
    imports: [BrightsideUiModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('fadeIn', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('500ms ease-out', style({ opacity: 1 }))
            ])
        ])
    ]
})
export class PayrollPendingCardComponent {

  private _translateService: TranslateService = inject(TranslateService);

  payrollPendingCellConfig : HeaderLabelCellConfig = {
    leftTitle:  this._translateService.instant('PAYROLL_DELAY_TITLE'),
    leftSubtitle : this._translateService.instant('PAYROLL_DELAY_DESC'),
    leftTitleSemibold: true,
    leftContentFullWidth: true,
    rightIconName: 'alert',
    rightIconColor: 'var(--red-50)',
    bgColor: 'var(--red-5)',
    minHeight: '2.2rem'
  }
}
